import { toasts } from "svelte-toasts";
import AppConfig from "../../app.config";
import Session from "./Session";
export default class Import {
    static async products(file, mode) {
        const token = Session.getToken();
        const body = new URLSearchParams();
        const fileReader = new FileReader();
        fileReader.readAsText(file);
        fileReader.onload = async function () {
            body.append('content', this.result.toString());
            const res = await fetch(`${AppConfig.REST.URL}/import/products?mode=${mode}&token=${token}`, { method: 'POST', body });
            if (res.status == 200)
                toasts.success(`Sukces`, `Aktualizacja produktów powiodła się`);
        };
    }
}
Import.ABS = {
    products: async (defaultDiscount, restoreRemovedProducts) => {
        const token = Session.getToken();
        const res = await fetch(`${AppConfig.REST.URL}/import/products/abs-pos/sync?discount=${defaultDiscount}&token=${token}&restore=${restoreRemovedProducts}`);
        const json = await res.json();
        return json;
    }
};
